<template>
  <div class="OrderPriceValidationAlert">
    <p>商品金額2,000円より購入いただけます。2,000円以上になるように商品を追加してください。</p>
    <TextLink
      v-if="showProductSearchLink && !!genre"
      error
      text="カードを検索"
      :to="`/${genre}/search`"
    />
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#imports'
import { TextLink } from '@ka-nabellinc/ka-nabell-ui'
import type { Genre } from '@/types/genre'

export default defineNuxtComponent({
  components: {
    TextLink,
  },
  props: {
    showProductSearchLink: {
      type: Boolean,
      default: false,
    },
    genre: {
      type: String as () => Genre,
      default: null,
    },
  },
})
</script>

<style scoped>
.OrderPriceValidationAlert {
  padding: 12px 16px;
  color: var(--semantic-colors-text-red);
  border: solid 1px var(--semantic-colors-border-error);
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
</style>
